import EstimationTaskReminderModalComponent from './estimation-task-reminder-modal.component'

const EstimationTaskReminderModalModule = angular.module('cdbl.estimation-task-reminder-modal', [

])
  .component('cdblEstimationTaskReminderModal', EstimationTaskReminderModalComponent)
  .name

export default EstimationTaskReminderModalModule
